module.exports = __webpack_public_path__ + "img/finish_tag.1c55691c.png";